import { IconProps } from "@/data/types"

export default function AddIcon({ width=24, height=24, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.43994 6H12.4399M6.93994 0.5V11.5" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  )
}